import React from 'react';
import {connect} from 'react-redux';
import Jibber from '/app/src/jibber'
import {Flex, SVGButton} from '/app/src/component'
import _ from 'lodash'

import Header from './_header'
import Item from './_item'
import {ExchangeModel} from '/app/src/model'


const AllButtonNotificationStyle = {
    text: 'Alla',
    fontSize: '14px',
    height: '28px',
    marginLeft: '5px',
    marginBottom: '5px',

    color: 'black',
    backgroundColor: 'mediumgrey',
    borderActive: 'JibberBlue_M',
    backgroundActive: 'LightBlue1'
}



class ExchangeNotification extends Jibber {
    constructor(props){
        super(props)
        this.setAllNotification=this.setAllNotification.bind(this)
        this.updateItem = this.updateItem.bind(this)
    }

    checkNotification(){
        var {options} = this.props
        for(var o in options){
            if(options[o].notification === false) return false;
            for(var c in options[o].children){
                if(options[o].children[c].notification === false) return false;
            }
        }
        return true
    }

    setAllNotification(){
        var {options} = this.props
        var notification = !this.checkNotification(options)

        options.forEach((o)=>{
            o.notification = notification
            o.children.forEach((c)=>{
                c.notification = notification
            })
        })
        this.props.updatesRequest(options)
    }

    updateItem(id, sub_id){
        var {options} = this.props
        var index = _.findIndex(options, ['id', id])
        var notification
        if(sub_id){
            // change the notification of the children
            var sub_index = _.findIndex(options[index].children, ['id', sub_id])
            notification = options[index]['children'][sub_index].notification
            options[index]['children'][sub_index].notification = !notification

            // making sure parent notification are align to child option notification
            notification = false
            options[index]['children'].forEach((c)=>{
                // we only care for visible child opinion
                if(c.visible) {
                    if(c.notification){
                        notification = true
                    }
                }
            })
            options[index].notification = notification

            this.props.updatesRequest(options)
            return;
        }
        notification = options[index].notification
        options[index].notification = !notification
        options[index].children.forEach((c)=>{
            c.notification = !notification
        })
        this.props.updatesRequest(options)
    }

    render() {
        const {options} = this.props
        if(options.length === 0) return null;
        const active = this.checkNotification(options)
        const isAnyActive = ExchangeModel.selector.isAnyActive(options)
        return(
              <Flex column position='relative' shrink={0}>
                  <Header/>
                  <Flex wrap mt='10px'>
                      <SVGButton
                          active={active}
                          onClick={this.setAllNotification}
                          src={isAnyActive?'/images/Notifications_S.svg':'/images/Notifications_Mute_S.svg'}
                          {...AllButtonNotificationStyle}
                        />
                      {_.map(options, (item)=>{
                          if(item.visible){
                              return <Item key={item.id} item={item} onUpdateItem={this.updateItem}/>
                          }
                      })}
                  </Flex>
              </Flex>
        )
    }
}
const  {selector: readSelector, dispatcher: readRequest} = ExchangeModel.read()
const  {dispatcher: updatesRequest} = ExchangeModel.updates()

const mapDispatchToProps = (dispatch, props) =>({
    readRequest: ()=> dispatch(readRequest()),
    updatesRequest: (options)=>dispatch(updatesRequest(options))
})


const mapStateToProps = (state, props) => ({
    networkReadRequest: readSelector.network(state),
    options: readSelector.options(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeNotification);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/LeftPanel/ExchangeNotification/index.js